import base from './base2.repository'

export default {
    ...base,
    savePersonEntry(payload) {
        return new Promise((resolve, reject) => {
            this.post('vigilance/access-control/person-entry', payload)
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    searchPersonOrVisitor(payload) {
        return new Promise((resolve, reject) => {
            this.get(
                `vigilance/person-or-visitor/document/${payload.document}/client/${payload.clientId}`
            )
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    searchPerson(payload) {
        return new Promise((resolve, reject) => {
            this.get(
                `vigilance/person-or-visitor/document/${payload.document}/client/${payload.clientId}`
            )
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    getVisitorTypes() {
        return new Promise((resolve, reject) => {
            this.get('vigilance/visitor-types')
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    getVehicleEntryTypes() {
        return new Promise((resolve, reject) => {
            this.get('vigilance/vehicle-entry-types')
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    getEntries(clientId) {
        return new Promise((resolve, reject) => {
            this.get(`entries?client=${clientId}`)
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    reportAlarm(alarm) {
        return new Promise((resolve, reject) => {
            this.post('vigilance/alarms/report', alarm)
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    saveDeparture(payload) {
        return new Promise((resolve, reject) => {
            this.post('vigilance/departures/save', payload)
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    savePersonDeparture(entryId, notes, userId) {
        return new Promise((resolve, reject) => {
            this.post(`entries/${entryId}/person-departure?user=${userId}`, {
                notes,
            })
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    saveDepartureIsolated(payload) {
        return new Promise((resolve, reject) => {
            this.post('isolated-departures', payload)
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    receiveMail(payload) {
        return new Promise((resolve, reject) => {
            this.post(`mail`, payload)
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    distributionMail(payload) {
        return new Promise((resolve, reject) => {
            this.post(`clients/distribution-mail`, {
                userId: payload.userId,
                selectedStructures: payload.selectedStructures,
                typeId: payload.typeId,
                notes: payload.notes,
                clientId: payload.clientId,
            })
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    getMailTypes() {
        return new Promise((resolve, reject) => {
            this.get('vigilance/mail-types')
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    getPendingMail(clientId) {
        return new Promise((resolve, reject) => {
            this.get(`clients/${clientId}/pending-mail`)
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    getPendingMailPaged(clientId, page, filters) {
        const delivered = '0'
        const params = Object.assign(
            {},
            { page, delivered, client: clientId },
            filters
        )
        const queryString = this.querify(params)
        return new Promise((resolve, reject) => {
            this.get(`mail/paged${queryString}`)
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    getDeliveredMailPaged(clientId, page, filters) {
        const params = { ...filters, page, client: clientId, delivered: 1 }
        return new Promise((resolve, reject) => {
            this.get(`mail/paged${this.querify(params)}`)
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    saveMailDelivery(userId, mail) {
        return new Promise((resolve, reject) => {
            this.post(
                `clients/user/${userId}/mail/${mail.mailId}/deliver`,
                mail
            )
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    searchPlate(plate, clientId) {
        return new Promise((resolve, reject) => {
            this.get(`vehicles?client=${clientId}&plate=${plate}`)
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    getVisitorTypesByGroup(group) {
        return new Promise((resolve, reject) => {
            this.get(`vigilance/visitor-types/${group}/group`)
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    getPassengers(id) {
        return new Promise((resolve, reject) => {
            this.get(`vehicle-entries/${id}/passengers`)
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    registerVehicleDeparture(entryId, notes, passengers, userId) {
        return new Promise((resolve, reject) => {
            this.post(`vehicle-departures`, {
                entryId,
                notes,
                passengers,
                userId,
            })
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    searchPersonEntry(document, clientId) {
        return new Promise((resolve, reject) => {
            this.get(`person-entries/last/${document}?client=${clientId}`)
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    searchVehicleEntry(plate, clientId) {
        return new Promise((resolve, reject) => {
            this.get(`vehicle-entries/last/${plate}?client=${clientId}`)
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    saveVehicleDepartureIsolated(payload) {
        return new Promise((resolve, reject) => {
            this.post('vehicle-departures-isolated', payload)
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    getValidYears() {
        return new Promise((resolve, reject) => {
            this.get('utilities/valid-years')
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    searchPersonOrVehicle(clientId, term) {
        return new Promise((resolve, reject) => {
            this.get(
                `vigilance/${clientId}/person-or-vehicle` +
                    this.querify({ term })
            )
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    loadRestrictedVisitors(clientId) {
        return new Promise((resolve, reject) => {
            this.get(`vigilance/${clientId}/restricted-visitors`)
                .then(response => resolve(response.data))
                .catch(error => reject(error))
        })
    },
    tryPersonEntry(person, clientId, structureId, userId) {
        const payload = { person, clientId, structureId, userId }
        return this.post('vigilance/access-control/try-person-entry', payload)
    },
    confirmAssistance: (userId, personId, notes) =>
        base.post(`vigilance/confirm-assistance`, { userId, personId, notes }),
    requestAuthorization: payload =>
        base.post('vigilance/request-authorization', payload),
}
